<template>
  <div class="insurance-claim-analysis">
    
    <el-button size="small" v-if="!readonly" :disabled="saveloading" type="primary" @click="goFullScreen">Full
      Screen</el-button>
    <iframe :title="$t('Hadisələrin_təhlili_Power_Bi')" id="iframeReport" width="100%" height="541.25" :src="iframeSrc"
      frameborder="0" allowfullscreen="true">
    </iframe>
  </div>
</template>

<script>
  export default {
    name: 'InsuranceClaimAnalysis',
    data() {
      return {
        iframeSrc: 'https://app.powerbi.com/reportEmbed?reportId=16a396c6-ee44-4255-9e0d-555fbcc78b1c&autoAuth=true&ctid=53160810-74b1-4629-820d-49bd6b018aaf'
      };
    },
    methods: {
      goFullScreen() {
        const iframe = document.getElementById('iframeReport');
        if (iframe.requestFullscreen) {
          iframe.requestFullscreen();
        } else if (iframe.mozRequestFullScreen) { // Firefox
          iframe.mozRequestFullScreen();
        } else if (iframe.webkitRequestFullscreen) { // Chrome, Safari and Opera
          iframe.webkitRequestFullscreen();
        } else if (iframe.msRequestFullscreen) { // IE/Edge
          iframe.msRequestFullscreen();
        }
      }
    }
  };
</script>

<style scoped>
  .insurance-claim-analysis {
    max-width: 100%;
    overflow: hidden;
  }

  button {
    margin-bottom: 10px;
  }
</style>